// Shared formatting helpers

/**
 * Format ISO date string to human-readable Spanish format
 * "2026-04-12" → "12 abr 2026"
 * "2026-04-12T00:00:00Z" → "12 abr 2026"
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '—'
  try {
    const d = new Date(dateStr + (dateStr.length === 10 ? 'T12:00:00' : ''))
    if (isNaN(d.getTime())) return dateStr
    return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })
  } catch {
    return dateStr
  }
}

export const formatMoney = (n) =>
  `$${Number(n || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}`
